// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '한국프라임제약',
  targetSheetName: '품목별세부사항',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '기본 수수료율',
    commissionNote: '공지사항',
  },
  requiredHeaders: [
    '분류',
    '분류코드',
    '성분분류',
    '제품명',
    '성분',
    '주성분코드',
    '보험코드',
    '전문/일반',
    '약가',
    '기본 수수료율',
    '공지사항',
    '생동여부',
    '대조약',
  ],
});
